import { getMessages } from '../../../../../../../store/constants';

export const CARD_LINK = getMessages().getText('hint.card_link');
